import { differenceBy } from 'lodash'
import { IReservationWasTransfered } from '../../../actions/bookingCalendar/event/transferReservation'
import { IEventsStore } from '../../events'

export default function(
  state: IEventsStore,
  action: IReservationWasTransfered,
): IEventsStore {
  return {
    ...state,
    events: [...differenceBy(state.events, [action.event], 'id'), action.event],
  }
}
